(function( window ) {
    "use strict";

    window.KSBErrorLogging = function ( root, server_url, info ) {

        function post_js_error( log_msg ) {
            const xhr = new root.XMLHttpRequest();
            xhr.open( 'POST', server_url, true );
            xhr.setRequestHeader( 'Content-Type', 'application/json');
            xhr.send( JSON.stringify( log_msg ) );
        }

        function get_call_stack( foo ) {
            if ( ! foo ) {
                return '';
            }
            else if ( ! foo.stack ) {
                return '';
            }

            let stack = foo.stack
                .replace( /http(s)?:\/\/[^/]+/g, '' )
                .replace( /\?v=[a-z0-9]+:/g, ':' )
                .replace( /sessionID=[a-f0-9]+&/g, '' )
                .replace( / +/g, ' ' )
                .split( "\n" );

            const stack_len = stack.length;
            if ( stack_len > 7 ) {
                const omitted = stack_len - 4;
                stack.splice( 2, omitted, ` [${omitted} lines omitted]` );
            }

            return stack;
        }

        root.addEventListener('error', event => {
            const ksb_url = new URL( document.location.href );
            ksb_url.searchParams.delete( 'sessionID' );
            ksb_url.searchParams.delete( 'cID' );
            ksb_url.searchParams.delete( 'swtssa' );
            const causing_url = ksb_url.toString();
            const node = ksb_url.searchParams.get( 'node' );

            const ua = navigator.userAgent;
            if ( ua.indexOf( 'Gecko/20100101 Firefox/47.0' ) > -1 ) {
                // Unser legacy Selenium-Browser
                return false;
            }
            else if ( ua.indexOf( 'Mozilla/4.0 (compatible; MSIE 8.0; Windows NT 6.0)' ) > -1 ) {
                // Ein Kunde, der da wohl was automatisiert hat
                return false;
            }

            // https://askubuntu.com/q/110649
            if ( event.message.indexOf( 'NS_ERROR_FILE_CORRUPTED' ) > -1 ) {
                return false;
            }
            // different origin
            // https://bugzilla.mozilla.org/show_bug.cgi?id=363897
            else if ( event.message.indexOf( 'Script error' ) > -1 ) {
                return false;
            }

            let error_url = '';
            if ( URL.canParse( event.filename ) ) {
                const url = new URL( event.filename );
                // diverse browser-extension-interne Fehler:
                if ( url.protocol === 'chrome-extension:' ) {
                    return false;
                }
                else if ( url.protocol === 'safari-extension:' ) {
                    return false;
                }
                else if ( url.protocol === 'moz-extension:' ) {
                    return false;
                }
                url.searchParams.delete( 'sessionID' );
                url.searchParams.delete( 'cID' );
                url.searchParams.delete( 'swtssa' );
                url.searchParams.delete( 'v' );
                error_url = url.toString();
            }

            post_js_error( {
                "info"    : info,
                "message" : event.message,
                "node"    : node,
                "lineno"  : event.lineno,
                "colno"   : event.colno,
                "url"     : error_url,
                "stack"   : get_call_stack( event.error ),
                "causing_url" : causing_url,
            } );

            return false;
        });
    };
})( window );
